import React from 'react';

export default function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 320, maxWidth: '1200px', width: '90vw', maxHeight: '90vh', overflowY: 'auto' }}>
        <button onClick={onClose} style={{ float: 'right', marginBottom: 8 }}>×</button>
        {children}
      </div>
    </div>
  );
}
